import {  GET_USER_INFO_REQUEST } from '../constants/constants';

export const getUserInfo = (payload) => {
    return {
      type: GET_USER_INFO_REQUEST,
      payload: payload
    };
  };